import React from "react";
import ReactDOM from "react-dom/client";
import MapComponent from "./MapComponent";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaRegCheckCircle,
  FaMapMarkerAlt,
} from "react-icons/fa";
import HamdanyahMap from "./HamdanyahMap";
const locations = [
  { name: "Point A", latitude: 51.505, longitude: -0.09 },
  { name: "Point B", latitude: 51.515, longitude: -0.1 },
];
const Hamdanyah = () => {
  return (
    <section id="map" className=" myMap map features">
      <h2 className="features-heading">
        {" "}
        <span>:</span>تتوفر عدساتنا في المتاجر التالية{" "}
      </h2>
      <div className="feature-cards">
        {[
          {
            title: " Saveo Optics",
            desc: "الحمدانية - قره قوش - شارع الأطباء - بجانب صيدلية سامر كجو",
            phone: "07715690338",
            side: "right",
          },
        ].map((feature, index) => (
          <div
            key={index}
            className={`dark-cards feature-card ${feature.side}`}
          >
            <h4>
              <FaMapMarkerAlt className="check-icon" size={20} />
              {feature.title}
            </h4>

            <p>{feature.desc}</p>
            <li>
              <FaWhatsapp size={30} />{" "}
              <a href="https://wa.me/9647715690338">9647715690338+</a>
            </li>
          </div>
        ))}
      </div>

      <HamdanyahMap locations={locations} />
    </section>
  );
};

export default Hamdanyah;
